// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__n7DRG","content":"styles_content__1dIfc","selectAll":"styles_selectAll__3G4q3"};